export const TextConstants = {
  Buttons: {
    Add: "Add",
    AddBrokerExportConfiguration: "Add New Broker Export Configuration",
    AddBrokerFileType: "Add New Broker File Type",
    AddClientAccount: "Add New Client Account",
    AddCheckQuery: 'Add New Check Query',
    AddColumn: "Add New Column",
    AddDataValidation: 'Add New Data Validation Configuration',
    AddEmailAddress: "Add Email Address",
    AddFreeTextEventMapping: "Add New Free Text Event Mapping",
    AddNewOrganisationMapping: "Add New Organisation Mapping",
    AddInstrument: "Add New Instrument",
    AddInstrumentSubtype: "Add New Instrument Subtype",
    AddInstrumentType: "Add New Instrument Type",
    AddGenericMapping: "Add New Generic Mapping",
    AddKeyword: "Add Keyword",
    AddOrganisation: "Add New Organisation",
    AddNew: "Add New",
    AddNewExcludedAccount: "Add New Excluded Account",
    AddNewGroup: "Add New Group",
    AddNewBrokerFileSpecImportProcedure: "Add New Broker Import Procedure",
    AddNewEvent: "Add New Event",
    AddNewVersion: "Add New Version",
    AddNewTransaction: "Add New Transaction",
    AddSecurityTransfer: "Add New Security Transfer",
    AddServiceProvider: "Add New Service Provider",
    Assign: "Assign",
    AssignedBrokers: "Assigned Brokers",
    Back: "Back",
    BackToFileConfigurations: "Back to File Configurations",
    BackToServiceProviders: "Back to Service Providers",
    BrowseFilesHere: "Browse files here",
    CompleteCorporateActionEvent: "Complete Corporate Action Event",
    CompleteTradeOrders: "Complete Trade Orders",
    Confirm: "Confirm",
    BookCostCalculation: "Run Book Cost Calculation",
    ExecuteLBVH: "Execute LBVH",
    BulkUpdate: "Bulk Update",
    BulkUpdatePrice: "Bulk Update Price",
    Cancel: "Cancel",
    ClearInputs: "Clear Inputs",
    ClearSearch: "Clear",
    Close: "Close",
    CreateAsEvent: "Create as Event",
    Edit: "Edit",
    ExcludeAccount: "Exclude Account",
    Extract: "Extract",
    Decline: "Decline",
    DeclineBatch: "Decline Batch",
    DownloadCSV: "Download",
    GlobalRelease: "Release",
    GlobalDownload: "Download",
    GlobalSearch: "Search",
    Intercept: "Intercept",
    ManageAccountExclusions: "Manage Account Exclusions",
    MapAccount: "Map Account",
    MapEvent: "Map Event",
    MapInstrument: "Map Instrument",
    New: "New",
    No: "No",
    Normalise: "Normalise",
    ProcessTransactions: "Process Transactions",
    ProcessBatch: "Process Batch",
    PleaseSelectAnOption: 'Please select an option',
    Reinvite: "Re-invite",
    ReInstate: "Re-Instate",
    Reject: "Reject",
    Remove: "Remove",
    RequestAuthorisation: "Request Authorisation",
    ReturnToHome: "Return to Home",
    Reset: "Reset",
    RerunBookCost: "Rerun Book Cost",
    RunInterception: "Run Interception",
    RunInterceptionAndWAC: "Run Interception and WAC",
    RunProcess: "Run Process",
    RunWAC: "Run WAC",
    Save: "Save",
    Search: "Search",
    ShowLatestImports: "Latest",
    Submit: "Submit",
    Unlock: "Unlock",
    Update: "Update",
    Upload: "Upload",
    View: "View",
    ViewColumns: "View Columns",
    ViewConfiguredFiles: "View Configured Files",
    ViewImportProcesses: "View Import Processes",
    ViewMappings: "View Report Column Mappings",
    ViewSourceColumns: "View Source Columns",
    Yes: "Yes",
  },
  CachedData: {
    LifeTime: {
      Short: 15,
      Medium: 60,
      Long: 1440,
      VeryLong: 10080
    }
  },

  DateFormats: {
    dateMonthYear: "dd MMM yyyy"
  },

  GeneralText: {
    ProcessBatchQuestion: "Are you sure you want to process this request batch?",
    BatchNotesRequired: "Batch note required",
    BatchNotes: "Batch Notes",
    BulkUpdateMessage: "Are you sure you want to bulk update these {bulkSelectedNumber} records?",
    BulkUpdatePreview: "Previewing 10 of {bulkSelectedNumber} selected records for bulk update.",
    CompleteCorporateActionEvent: "Are you sure you want to complete this corporate action?",
    CompleteTradeOrders: "Are you sure you want to complete this trade order?",
    Declined: "Declined",
    DeclineBatch: "Decline Batch",
    DeclineBatchQuestion: "Are you sure you wish to decline this batch?",
    DeleteCorporateActionEvent: "Are you sure you want to delete this Corporate Action Event?",
    DeleteProcessingFile: "Are you sure you want to delete this processing file?",
    DeleteSecurityTransferConfirmation: "Are you sure you want to delete this security transfer?",
    DeleteStaticEventConfirmation: "Are you sure you want to delete this event?",
    ExcludeAccount1: "Excluding the account ",
    ExcludeAccount2: " means:",
    ExcludeAccount3: "All data for this account will be cleared from generic tables.",
    ExcludeAccount4: "Any future data that is received for this account will not be normalised and will therefore not be included in tax calculations.",
    Loading: "Loading",
    NewFileSpecSave: "This will save a new File Spec. Do you wish to continue?",
    NoRecords: "No records to display",
    NoUserGroups: "No User Groups",
    NoUserGroupsSecurity: "No User Group Security",
    Pending: "Pending",
    Processed: "Processed",
    ProcessBatch: "Process Batch",
    VersionOfFileSpecOverlaps: "Note, a version of this file spec is active for the same period. Do you want to continue saving?",
    EnterANote: "Please enter a short batch note.",
    UploadSecurityTransactionsCSV: "Upload Security Transactions CSV.",
    UploadSuccess: "Upload successful.",
    UploadCashTransactionsCSV: "Upload Cash Transactions CSV.",
  },

  ImportProcessTypes: {
    Interception: "Interception",
    Extraction: "Extraction",
    Normalise: "Normalise",
  },

  Labels: {
    AddResultInd: "Add Result To Mail",
    Account: "Broker Account",
    AccountCurrency: "Account Currency",
    AccountNumber: "Account Number",
    Action: "Action",
    ActiveEndDate: "Active End Date",
    ActiveStartDate: "Active Start Date",
    AdditionalInformation: "Additional Info",
    AdvancedSearch: "Advanced Search",
    AffectedTable: "Affected Table",
    AllowsNulls: "Allows Nulls",
    AlternativeAccountNumber: "Alternative Account Number",
    Amount: "Amount",
    AmountNC: "Amount NC",
    Assign: "Assign",
    AssignedInstrument: "Assigned Instrument",
    Balance: "Balance",
    BalanceNC: "Balance NC",
    BaseValueSoldNC: "Base Value Sold NC",
    BookTransfer: "Book Transfer",
    Broker: "Broker",
    BrokerAccount: "Broker Account",
    BrokerAccountCode: "Broker Account Code",
    BrokerAccountCurrency: "Broker Account Currency",
    BrokerAccountNumber: "Broker Account Number",
    BrokerCode: "Broker Code",
    BrokerDescription: "Broker Description",
    BuyAtBookCost: "Buy At Book Cost",
    Calculation: "Calculation",
    CalculationLogic: "Calculation Logic",
    CapitalGainEvent: "Capital Gain Event",
    CorporateActionReference: "Corporate Action Reference",
    CashNotCapitalised_Excl_Ind: "Cash Not Capitalised ",
    Cash: "Cash",
    CashFlow: "Cash Flow",
    CheckQueryName: "Check Query Name",
    ClientAccount: "Client Account",
    ClientAccountCurrency: "Client Account Currency",
    ClientAlternativeRefSearch: "Client Alternative Reference Search",
    ClientEntityType: "Client Entity Type",
    ClientName: "Client Name",
    ClientNumber: "Client Number",
    ColumnCount: "Column Count",
    ColumnHeaderStartLine: "Column Header Start Line",
    ColumnNumber: "Column Number",
    ContainsColumnHeader: "Contains Column Header",
    CorporateAction: "Corporate Action",
    CorporateActionReferenceRequired: "Corporate Action Reference Required",
    CorporateActionStage: "Corporate Action Stage",
    CorporateActionType: "Corporate Action Type",
    ConfirmedAmount: "Confirmed Amount",
    CreateAsInstrument: "Create As Instrument",
    CriticalFile: "Critical File",
    CriticalFailureRecipients: "Critical Failure Recipients",
    Currency: "Currency",
    CurrencyCodeAlternativeReference: "Currency Code Alternative Reference",
    Current: "Current",
    DatabaseName: "Database Name",
    DataReportDescription: "Data Report Description",
    DataTableInBody: "Data Table in Body",
    DataType: "Data Type",
    DataValidation: "Validation",
    Date: "Date",
    DateCreated: "Date Created",
    DateFormat: "Date Format",
    DateReport: "Date Report",
    DateEvent: "Event Date",
    DefaultErrTableReference: "Default Error Table Reference",
    DefaultNormalisedTableReference: "Default Normalised Table Reference",
    DefaultValue: "Default Value",
    Delete: "Delete",
    Deleted: "Deleted",
    Description: "Description",
    DestinationCorporateActionType: "Destination Corporate Action Type",
    DestinationEventType: "Destination Event Type",
    DestinationField: "Destination Field",
    DestinationTable: "Destination Table",
    Dividend: "Dividend",
    DividendsDeclaredAccountCurrency: "Dividends Declared Account Currency",
    DividendsDeclaredNC: "Dividends Declared Nominated Currency",
    DividendWithholdingTaxAccountCurrency: "Dividend Withholding Tax Account Currency",
    DividendsWithholdingTaxReportedNC: "Dividend Withholding Tax Reported Nominated Currency",
    DividendGrossRepresentation: "Dividend Gross Representation",
    DualListed: "Dual Listed",
    DWT: "DWT",
    Details: "Details",
    Edit: "Edit",
    EmailAddresses: "Email Addresses",
    EndDate: "End Date",
    Event: "Event Name",
    EventDate: "Event Date",
    EventDescription: "Event Description",
    EventDetail: "Event Detail",
    EventID: "Event ID",
    EventName: "Event Name",
    EventTime: "Event Time",
    EventType: "Event Type",
    Exchange: "Exchange",
    ExchangeName: "Exchange Name",
    ExcludeFromExport: "Exclude From Export",
    Exclude: "Exclude Transaction",
    ExcludeAll: "Exclude All",
    Excluded: "Excluded",
    ExcludeValueUnchanged: "Exclude Value Unchanged",
    ExecutionDate: "Execution Date",
    ExistingClient: "Existing Client",
    ExternalReference: "External Reference",
    ExternalTransfer: "External Transfer",
    ExpectedAmount: "Expected Amount",
    Exports: "Exports",
    ExportData: "Export Data",
    ExportDate: "Export Date",
    ExportLocation: "Is Export Location",
    ExportReport: "Export Report",
    ExportReportReference: "Export Report Reference",
    EventIdFieldName: "EventId Field Name",
    ExportsWhenReady: "Exports When Ready",
    FieldName: "Field Name",
    FileDelimiter: "File Delimiter",
    FileExtension: "File Extension",
    FileFieldName: "File Field Name",
    FileNameConvention: "File Name Convention",
    FileType: "File Type",
    FilesInProcessing: "Files In Processing",
    FilterClause: "Filter Clause",
    FinancialYear: "Financial Year",
    Format: "Format",
    FromStockbroker: "From Stockbroker",
    FromAccount: "From Account",
    GeneratesTransactionRecord: "Generates Transaction Record",
    GenericJoinField: "Generic Join Field",
    GenericSourceTable: "Generic Source Table",
    IgnoreColumn: "Ignore Column",
    IgnoreExchangeRates: "Ignore Exchange Rates",
    IgnoreFile: "Ignore File",
    IgnoreGrouping: "Ignored",
    ImportDate: "Import Date",
    IsIWTInd: "Interest Withholding Tax",
    IsTradeOrder: "Is Trade Order",
    IsValuation: "Is Valuation",
    Imports: "Imports",
    ImportProcessStep: "Import Process Step",
    ImportsOnPublicHolidays: "Imports On Public Holidays",
    Inactive: "Inactive",
    IncludeAll: "Include All",
    IncludeCashTransactions: "Include Cash Transactions",
    IncludeSecurityTransactions: "Include Security Transactions",
    IncomeDeclaredAccountCurrency: "Income Declared Account Currency",
    IncomeDeclaredNC: "Income Declared Nominated Currency",
    InterestWithholdingTaxAccountCurrency: "Interest Withholding Tax Account Currency",
    InterestWithholdingTaxReportedNC: "Interest Withholding Tax Reported Nominated Currency",
    Instrument: "Instrument",
    InstrumentCode: "Instrument Code",
    InstrumentCurrency: "Instrument Currency",
    InstrumentDescription: "Instrument Description",
    InstrumentExchange: "Instrument Exchange",
    InstrumentName: "Instrument Name",
    InstrumentSubType: "Instrument Subtype",
    InstrumentSubTypeName: "Instrument Subtype Name",
    InstrumentTypeName: "Instrument Type Name",
    Interest: "Interest",
    InternalTransfer: "Internal Transfer",
    IsActive: "Active",
    IsClientAltSearch: "Is Client Alternative Search",
    Isin: "ISIN",
    IsinCode: "IsinCode",
    IsOnShore: "Onshore",
    IsSent: "Sent",
    IsWacEnabled: "Is Weighted Average Cost Enabled",
    Iteration: "Iteration",
    JoinClause: "Join Clause",
    HoldingReportingDate: "Holding Reporting Date",
    LastExecutionDate: "Last Execution Date",
    LateCronSchedule: "Late Cron Schedule",
    ListedInstrument: "Listed instrument",
    MappedDirectlyFromSourceField: "Mapped directly from source field",
    MarkAsPendingForExport: "Mark as pending for export",
    MarkAsUnsent: "Mark as Unsent",
    MarketPrice: "Market Price",
    MarketValueInstrumentCurrency: "Market Value (Instrument Currency)",
    MarketValueNC: "Market Value (NC)",
    MaturityDate: "Maturity Date",
    MaxVariance: "Max Variance",
    MinVariance: "Min Variance",
    NewClient: "New Client",
    NewEvent: "New Event",
    NewEventMapping: "New Event Mapping",
    NewInstrument: "New Instrument",
    NewInstrumentMapping: "New Instrument Mapping",
    NewValue: "New Value",
    NextExecutionDate: "Next Execution Date",
    Notes: "Notes",
    NumberOfUpdates: "Number of Updates",
    OldValue: "Old Value",
    OnlyExcluded: "Only Excluded",
    OnlyIncluded: "Only Included",
    Onshore: "Onshore",
    OrganisationName: "Organisation Name",
    PortfolioBookPrice: "Portfolio Book Price",
    PortfolioBookPriceNC: "Portfolio Book Price NC",
    PortfolioBookPriceInstrumentCurrency: "Portfolio Book Price (Instrument Currency)",
    PositiveValue: "Positive Value",
    Price: "Price",
    PriceFactor: "Price Factor",
    PrimeTimeCronSchedule: "Prime Time Cron Schedule",
    ProceedsNC: "Proceeds NC",
    Process: "Process",
    Processed: "Processed",
    ProcessPriority: "Process Priority",
    ProcessSortOrder: "Process Sort Order",
    ProcessedAsNegativeBuy: "Processed As Negative Buy",
    ProvidesDividendGross: "Provides Dividend Gross",
    ProvideResultSetInEmailBody: "Provide Result Set in Email Body",
    ProvisionalCGTValueNC: "Provisional CGT Value Nominated Currency",
    ProvisionalIWTValueNC: "Provisional IWT Value Nominated Currency",
    ProvisionalDWTValueNC: "Provisional DWT Value Nominated Currency",
    Quantity: "Quantity",
    QuantityNotValue: "Quantity Not Value",
    RawAccountID: "Broker Account",
    RawCorporateActionType: "Raw Corporate Action Type",
    RawEventID: "Raw Event ID",
    RawEventType: "Raw Event Type",
    RawTableReference: "Raw Table Reference",
    RealisedGainOrLossAccountCurrency: "Realised Gain Or Loss Account Currency",
    RealisedGainOrLossNC: "Realised Gain Or Loss Nominated Currency",
    RealisedGainNC: "Realised Gain NC",
    RejectionReason: "Rejection Reason",
    REIT: "Real Estate Investment Trust",
    RelatedTrasactionID: "Related Transaction ID",
    ReportColumnName: "Report Column Name",
    ReportDate: "Report Date",
    ReportingDate: "Reporting Date",
    Reversal: "Reversal",
    RunForServiceProvider: "Run for Service Provider",
    RunFrequency: "Run Frequency (Hours)",
    RunFrequencyMinutes: "Run Frequency (Minutes)",
    RunWACRollover: "Run WAC Rollover",
    SAMReporting: "Sam Reporting",
    IsBroker: "Is Broker",
    IsBookCostRunning: "Is Book Cost Running",
    LastDailyReportSync: "Last Daily Report Sync",
    ExportToSFTP: "Export To SFTP",
    ExportToAPI: "Export To API",
    SearchCheckQueries: "Search Check Queries",
    SearchColumns: "Search Columns",
    SearchEvents: "Search Events",
    SearchInstruments: "Search Instruments",
    SearchSecurityTransfers: "Search Security Transfers",
    SearchServiceProviders: "Search Service Providers",
    SearchStockbrokerFileSpecs: "Search Stockbroker File Specs",
    Security: "Security",
    SecurityCode: "Security Code",
    Select: "Select",
    SellAtBookCost: "Sell At Book Cost",
    Sent: "Sent",
    ServiceProvider: "Service Provider",
    ServiceProviderGroupingName: "Service Provider Grouping Name",
    SFTPSetting: "SFTP Setting",
    SFTPDirectory: "SFTP Directory",
    SingleFile: "Single File",
    StartDate: "Start Date",
    StaticServiceProviderHouseCheckQueryID: "Static Service Provider House Check Query ID",
    StaticServiceProviderID: "Static Service Provider ID",
    Status: "Status",
    SortOrder: "Sort Order",
    SourceField: "Source Field",
    SourceTable: "Source Table",
    StoredProcedure: "Stored Procedure Name",
    SystemGrouping: "System Grouping",
    TableColumnName: "Table Column Name",
    Transfer: "Transfer",
    TaxableTransfer: "Taxable Transfer",
    TickerSymbol: "Ticker Symbol",
    ToAccount: "To Account",
    TotalGrossNC: "Total Gross NC",
    ToStockbroker: "To Stockbroker",
    TransactionAmount: "Transaction Amount",
    TransactionAmountNC: "Transaction Amount NC",
    TransactionDate: "Transaction Date",
    TransactionID: "Transaction ID",
    TransactionQuantity: "Transaction Quantity",
    TransactionTime: "Transaction Time",
    TransferEntryDate: "Transfer Entry Date",
    TriggerNextExecutionDate: "Trigger Next Execution Date",
    UnassignClientMapping: "Unassign Client Mapping",
    UnderlyingSecurityCode: "Underlying Security Code",
    UniqueValue: "Unique Value",
    UnitPrice: "Unit Price",
    UnitPriceInstrumentCurrency: "Unit Price (Instrument Currency)",
    UnrealisedGainOrLoss: "Unrealised Gain or Loss Nominated Currency",
    UpdatePriceToBookCost: "Update Price To Book Cost",
    UsesAccountCurrency: "Uses Account Currency",
    Value: "Value",
    ValueDate: "Value Date",
    ValueExcludes: "Value Excludes",
    ValueIncludes: "Value Includes",
    ValueNC: "Value NC",
    ZeroPrice: "Zero Price",
  },

  Notifications: {
    AccountMappingSaved: "Account mapping has been saved. Note that only the client account record has been updated and not the account's associated trading data.",
    ConfirmedAmountRequired: "Confirmed Amount is required and cannot be 0.",
    AttachmentUploadFailed: "The attachment could not be uploaded. Please try again.",
    BaseCostCalculationCurrentlyProcessingForCurrentBroker: "Please note that a base cost calculation is currently processing for the current broker.",
    CorporateActionEventSaved: "Corporate action event has been saved.",
    CorporateActionEventTransactionsSaved: "Corporate action event transactions price has been saved.",
    ColumnSaved: "Column Saved.",
    EventDeleted: "Event successfully deleted",
    EventSaved: "Event has been successfully saved.",
    ExcludedAccountSaved: "Excluded Account Saved",
    ImportConfigSuccessful: "Successfully saved File Import Configuration",
    InterceptionFailed: "Interception failed",
    InterceptionInitiated: "Interception initiated",
    InstrumentSavedSuccessfully: "The Instrument has been successfully saved.",
    FailedSubmission: "An error occurred, please try again.",
    FileDownloadSuccessful: "File downloaded successfully",
    FileSizeExceedsLimit: "File size exceeds 10MB limit. Please select a smaller file.",
    FileSpecSaved: "The file spec has been successfully saved.",
    FreeTextEventMappingSaved: "Free text event mapping has been successfully saved.",
    ProcessingFileDeleted: "Processing File Deleted Successfully.",
    ScheduleWAC: "WAC Scheduled",
    ScheduleWACFailure: "WAC Scheduling Failed",
    SecurityTransferDeleted: "Security Transfer successfully deleted",
    SecurityTransferSaved: "Security transfer has been successfully saved.",
    SuccessfulEventMappingUpdate: "Event mapping updated.",
    SuccessfulInstrumentMappingUpdate: "Instrument mapping updated",
    SuccessfulTransactionUpdate: "Successfully updated Transaction/s",
    TradeOrderSaved: "Trade order has been successfully saved.",
    UpdateColumnNumberAlert: "Updating the column number may result in this file spec's columns being re-ordered.",
    UnableToSetRawImportLog: "Unable to set raw import log.",
    UnsuccessfulTransactionUpdate: "The currency and book cost cannot be updated simultaneously.",
    UpdateRequestCreated: "Transaction update request(s) created.",
    UpdateRequestFailed: "Transaction update request(s) failed. No file selected.",
    MissingRequiredFields: "Required field/s are missing input",
    Warning: "Warning!",
    WeightedAverageCostProcessFailed: "Failed to start Weighted Average Cost process.",
    WeightedAverageCostProcessSuccessful: "Weighted Average Cost process has been started successfully.",
  },

  PlaceHolder: {
    ClientName: "clientName",
    ClientNumber: "clientNumber",
    DefaultErrorTablePlaceholder: "e.g. ErrRawBrokerNameDailyTransactions",
    DefaultNormalisedTablePlaceholder: "e.g. RawGenericSecurityTransactions",
    EventDescription: "e.g. The booking due to buying or selling a share.",
    EventName: "e.g. Trade Amount",
    ExportReportPlaceholder: "e.g. CashHoldings",
    ExportReportReferencePlaceholder: "e.g. [RptProcs].[RptKaneCashHoldingsExtract]",
    FileDelimiterPlaceholder: "e.g. Comma",
    FileDescriptionPlaceholder: "e.g. This file provides the trades executed during the course of a trade day.",
    FileExtensionPlaceholder: "e.g. .csv",
    FileNameConvention: "e.g. BrokerName_DailyTransactions",
    FileTypePlaceHolder: "e.g. BrokerName_DailyTransactions",
    FormatPlaceholder: "e.g. verboseCSV",
    InstrumentName: "e.g. Amazon.com Inc",
    ISIN: "e.g. US0231351067",
    ProcessSortOrder: "e.g. aab",
    RawTableReferencePlaceholder: "e.g. RawBrokerNameDailyTransactions",
    Search: "Search",
    SearchBrokerExportConfigurations: "Search Broker Export Configurations...",
    SearchBrokerFileTypes: "Search Broker File Types...",
    SearchDataValidationConfiguration: "Search Data Validation Configurations...",
    SearchCheckQueryConfigurations: "Search Check Query Configurations...",
    SearchClientAccounts: "Search Client Accounts...",
    SearchColumns: "Search Columns...",
    SearchCorporateActionEvents: "Search Corporate Action Events...",
    SearchEvent: "Search Events...",
    SearchEventMapping: "Search Event Mappings...",
    SearchEvents: "Search Events...",
    SearchExcludedAccounts: "Search Excluded Accounts...",
    SearchFileConfig: "Search File Configurations...",
    SearchFreeTextEventMappings: "Search Free Text Event Mappings...",
    SearchGenericMappings: "Search Generic Mappings",
    SearchGenericExportMappings: "Search Generic Export Mappings",
    SearchInstrumentTypes: "Search Instrument Types...",
    SearchInstrument: "Search Instruments...",
    SearchInstrumentMapping: "Search Instrument Mappings...",
    SearchInstrumentsCriteria: "Search Instruments...",
    SearchSecurityTransfersCriteria: "Search Security Transfers...",
    SearchServiceProviderDetails: "Search Service Providers...",
    SearchTradeOrders: "Search Trade Orders...",
    SelectImportDaysForBroker: "Select Import Days for Broker...",
    Ticker: "e.g. AMZN",
    ViewTradeOrdersPermissionDenied: "You do not have permission to view trade orders.",
  },

  SourceFieldStaticOptions: {
    Blank: "BLANK",
    Calc: "CALC",
    Default: "DEFAULT",
    GenGIEvent: "GENGIEVENT",
  },

  RegularExpression: {
    Alphanumeric: /^[0-9a-zA-Z\s\-']+$/,
  },

  StringFormats: {
    FormatString: "R #,###,##0.00; R -#,###,##0.00",
    FormatStringNoSymbols: "#,###,##0.00; -#,###,##0.00",
    DateFormat: "dd MMM yyyy"
  },

  Titles: {
    AddAccountExclusion: "Add Account Exclusion",
    RequiredField: "Required Field",
    AddBrokerExportConfiguration: "Add Broker Export Configuration",
    AddClientAccount: "Add Client Account",
    AddColumn: "Add Column",
    AddDataValidationConfiguration: "Add Data Validation Configuration",
    AddCheckQueryConfiguration: "Add Check Query Configuration",
    AddEvent: "Add Event",
    AddNewExportFileSpec: "Add New Export File Specification",
    AddFileSpec: "Add File Spec Configuration",
    AddGenericMapping: "Add Generic Mapping",
    AddGenericExportMapping: "Add Generic Export Mapping",
    AddFreeTextEventMapping: "Add Free Text Event Mapping",
    AddNewFileSpec: "Add New File Specification",
    AddNewOrganisation: "Add New Organisation",
    AddInstrument: "Add Instrument",
    AddSecurityTransfer: "Add Security Transfer",
    AddServiceProviderFileGrouping: "Add Service Provider File Grouping",
    AddStaticEvent: "Add Event",
    AddStockbrokerFileConfiguration: "Add Stockbroker File Configuration",
    AccessDenied: "Access Denied",
    AssignEvent: "Assign Event",
    AssignInstrument: "Assign Instrument",
    AttachmentOptional: "Attachment (Optional)",
    AttachmentUploadFail: "Attachment Upload Failed",
    Authorisation: "Authorisation",
    AuthorisationRequest: "Authorisation Request",
    BatchColumnHeadings: "Batch Column Headings",
    BatchInfo: "Batch Info",
    BookCostConfiguration: "Book Cost Configuration",
    BrokerCheckQueries: "Broker Check Queries",
    BrokerExportConfiguration: "Broker Export Configuration",
    BrokerFileConfiguration: "Broker File Configuration",
    BrokerFileSpecImportProcedures: "Broker File Spec Import Procedures",
    BulkPriceUpdate: "Bulk Price Update",
    BulkSelectionUpdate: "Bulk Selection Update",
    CancelFileProcessing: "Cancel File Processing",
    CashDividends: "Cash Dividends",
    CashDWT: "Cash DWT",
    CashHoldings: "Cash Holdings",
    CashTransactions: "Cash Transactions",
    CheckQueries: "Check Queries",
    CheckQueryTiers: "Check Query Tiers",
    CheckQueryConfiguration: "Check Query Configuration",
    Client: "Client",
    ClientAccounts: "Client Accounts",
    ClientAccountMapping: "Client Account Mapping",
    ColumnConfiguration: "Column Configuration",
    ConfirmAccountExclusion: "Confirm Account Exclusion",
    ConfirmBulkPriceUpdate: "Confirm Bulk Price Update",
    ConfirmCorporateActionReferenceUpdate: "Confirm Corporate Action Reference Update",
    ConfirmTradeOrder: "Confirm Trade Order",
    CorporateActionEvents: "Corporate Action Events",
    Currencies: "Currencies",
    DataValidationConfiguration: "Data Validation Configuration",
    DataValidationReport: "Data Validation",
    DeleteEvent: "Delete Event",
    DeleteProcessingFile: "Delete Processing File",
    DeleteSecurityTransfer: "Delete Security Transfer",
    DividendTransactions: "Dividend Transactions",
    DividendWitholdingTaxTranscations: "Dividend Withholding Tax Transactions",
    EditBrokerExportConfiguration: "Edit Broker Export Configuration",
    EditCheckQueryConfiguration: "Edit Check Query Configuration",
    EditClientAccount: "Edit Client Account",
    EditColumn: "Edit Column",
    EditCorporateActionEvent: "Edit Corporate Action Event",
    EditDataValidationConfiguration: "Edit Data Validation Configuration",
    EditInstrument: "Edit Instrument",
    EditExportFileSpec: "Edit Export File Specification",
    EditFileSpec: "Edit File Spec Configuration",
    EditFreeTextEventMapping: "Edit Free Text Event Mapping",
    EditOrganisation: "Edit Organisation",
    EditGenericMapping: "Edit Generic Mapping",
    EditGenericExportMapping: "Edit Generic Export Mapping",
    EditSecurityTransfer: "Edit Security Transfer",
    EditServiceProviderFileGrouping: "Edit Service Provider File Grouping",
    EditStaticEvent: "Edit Event",
    EditStockbrokerFileConfiguration: "Edit Stockbroker File Configuration",
    EditSFTPDetails: "Edit SFTP Details",
    EditTradeOrder: "Edit Trade Order",
    Error: "Error",
    EventMapping: "Event Mapping",
    Events: "Events",
    ExcludedAccounts: "Excluded Accounts",
    ExportColumnConfiguration: "Export Column Configuration",
    Exports: "Exports",
    FailedFileDownload: "File downloaded error",
    FailedTransactionUpdate: "Transaction Update Failed",
    FileConfigurations: "File Configurations",
    FileTooLarge: "File Too Large",
    FreeTextEventMappings: "Free Text Event Mappings",
    FullDisinvestment: "Full Disinvestment",
    GenerateNewTransaction: "Generate New Transaction",
    GenerateTransactions: "Generate Transactions",
    GenericMappings: "Generic Mappings",
    GenericExportMappings: "Generic Export Mappings",
    FreeTextEventMapping: "Free Text Event Mapping",
    Holdings: "Holdings",
    HoldingsExtract: "Holdings Extract",
    Home: "Home",
    Imports: "Imports",
    ImportProcedures: "Import Procedures",
    Instrument: "Instrument",
    Instruments: "Instruments",
    InstrumentDetails: "Instrument Details",
    InstrumentMapping: "Instrument Mapping",
    InstrumentTypeDetails: "Instrument Type Details",
    InstrumentTypeMaintenance: "Instrument Type Maintenance",
    InstrumentTypes: "Instrument Types",
    InstrumentMappingsToAssign: "Instrument Mappings to Assign",
    InterceptionFailed: "Interception Failed",
    InterceptionInitiated: "Interception Initiated",
    InterestTransactions: "Interest Transactions",
    InterestWithholdingTransactions: "Interest Withholding Transactions",
    InvitedUsers: "Invited Users",
    LockedOutUsers: "Locked Out Users",
    ManageAccountExclusions: "Manage Account Exclusions",
    ManageCheckQueryConfiguration: "Manage Check Query Configuration",
    ManageFileGroupingImportProcedure: "Manage File Grouping Import Procedure",
    MapClientAccount: "Map Client Account",
    Members: "Members",
    MissingAccountMappings: "Missing Account Mappings",
    Organisations: "Organisations",
    OrganisationConfiguration: "Organisation Configuration",
    ProvisionalTaxReports: "Provisional Tax Reports",
    RealisedGainsSummary: "Realised Gain/Loss Transactions",
    ReinstateTradeOrder: "Re-instate Trade Order",
    RejectTradeOrder: "Reject Trade Order",
    ReportValidationStatus: "Report Validation Status",
    ResetProcessingFile: "Reset Processing File",
    RunProcesses: "Run Processes",
    Roles: "Roles",
    RunInterception: "Run Interception",
    ScheduleTasks: "Schedule Tasks",
    SecurityHoldings: "Security Holdings",
    SecurityTransactions: "Security Transactions",
    SecurityTransfers: "Security Transfers",
    ServiceProviders: "Service Providers",
    SearchCriteria: "Search Criteria",
    SelectAll: "Select All",
    TaxSummary: "Tax Summary",
    TradeOrders: "Trade Orders",
    Transactions: "Transactions",
    TransactionInterception: "Transaction Interception",
    TradeOrdersSearch: "Trade Orders Search",
    SFTPDetails: "SFTP Details",
    Success: "Success",
    SystemConfiguration: "System Configuration",
    UnderlyingTransactions: "Underlying Transactions",
    UpdateEvent: "Update Event",
    UpdateTransactions: "Update Transactions",
    Upload: "Upload",
    UnrealisedGainsSummary: "Unrealised Gain/Losses",
  },

  Tooltips: {
    ActiveInactive: "Active/Inactive",
    AmountTooltip: "The transaction amount denoted in the event currency.",
    AmountUSD: "The transaction amount converted to USD.",
    CashNotCapitalisedExclIndInfo: "This attribute is specific to the process through which costs are capitalised and is marked as true where a cash event can be attributed to a security event but should not be capitalised into the book cost calculation.",
    CurrencyInfo: "The currency of the original event.",
    DailySyncServiceProviderFileGrouping: "Re-sync the export report data for the current day for this service provider file grouping.",
    DataTableInBodyInfo: "This indicates whether the results of the check query are included in the body of the email instead of being received as an email attachment.",
    DefaultErrorTableReference: "The name of the error table which stores raw data that is not successfully imported into the raw data table.",
    DefaultNormalisedTableReferenceInfo: "The name of the STODAR generic table where normalised data is stored.",
    EditBrokerFileConfiguration: "Edit Broker File Configuration",
    EditFileConfigutationTooltip: "Edit File Configuration",
    EventNameTooltip: "The event type to which the transaction has been mapped.",
    FileNameConventionTooltip: "The file name convention must match the expected file name.",
    EventIdInfo: "This field populates the Raw_EventID column to allow a generic transaction to relate to a raw transaction. The unique EventID field is generated by STODAR.",
    ExcludedIndInfo: "Transaction is excluded from book cost calculations and reconciliations.",
    ExcludeFromExportInfo: "When enabled, transactions mapped to this event will be excluded from daily export datasets.",
    ExternalReferenceInfo: "This field is used to store a reference that is specific to the third-party and is used to identify the transaction in the third-party system.",
    IsBuyAtBookCostEventIndicatorInfo: "This attribute triggers certain components of the Weighted Average Cost calculation to buy in an entry at the book cost of the portfolio so that the base cost is rolled over from a prior calculation.",
    IsCashFlowIndicatorInfo: "This attribute is used to flag that a static event is specifically meant to be associated with a cash or security entry. It is the starting point in the decision making process for the assignment of an event.",
    IsIWTIndInfo: "This attribute is a driver of key elements of the reporting process to flag entries which should be reported in the tax/income processes as interest tax that was withheld.",
    IsCapitalGainEventIndicatorInfo: "This attribute will determine if the event should be included in the Weighted Average Cost calculation which in turn will have an effect on the base costs, capital gains and losses and reports on such items.",
    IsCapitalGainQtyNotValIndicatorInfo: "This attribute is specific to events such as return of capital where the book cost calculation will ignore the quantity associated with the record.",
    IsCorporateActionIndicatorInfo: "This attribute is used to flag if an event (either cash or security) is linked to the specific types of entries associated with Corporate Actions. This will allow for enhanced reporting and flagging that events may require specific tax attention.",
    IsCorporateActionReferenceRequiredInfo: "Denotes that a corporate action requires a valid CGT reference before being exported.",
    IsDeletedIndicatorInfo: "Deleted events are soft-deleted from the static events list.",
    IsDividendEventIndicatorInfo: "This attribute is a driver of key elements of the reporting process to flag entries which should be reported in the tax/income processes as dividends under SA tax law.",
    IsDWTIndicatorInfo: "This attribute is a driver of key elements of the reporting process to flag entries which should be reported in the tax/income processes as dividend tax that was withheld.",
    IsInterestIndicatorInfo: "This attribute is a driver of key elements of the reporting process to flag entries which should be reported in the tax/income processes as interest received.",
    IsSellAtBookCostEventIndicatorInfo: "This attribute triggers certain components of the Weighted Average Cost calculation to sell out at an entry at the book cost of the portfolio so that no gain or loss is triggered.",
    IsTransferInicatorInfo: "Transfer or partial transfer of share or share portfolio within the broker ",
    IsProcessedAsNegativeBuyIndicatorInfo: "This attribute is specific to events such as returns of capital through which the base cost of a share must be decreased but no sell event has taken place.",
    IsZeroPriceEventIndicatorInfo: "This attribute is specific to event types where no price is expected to be associated with the event and is linked to certain types of check queries.",
    ImportProcessStepIndicatorInfo: "Altering the Import Process Step will update the check query Import Process Step reference for all brokers.",
    MarketValueTooltip: "The market value of the instrument on the transaction date denoted in the event currency.",
    ProcessSortOrderTooltip: "This specifies the order in which the selected stockbroker's files will be imported relative to each other.",
    PriceUpdateTooltip: "The new unit price of the transaction expressed in cents.",
    RawTableReferenceInfo: "The name of the table into which raw data is directly imported and saved.",
    RelatedTransactionIDInfo: "This indicates the transaction identifier of any transactions that may be related, such as a reversed transaction.",
    RunsForServiceProviderInfo: "This indicates whether the check query runs for the service provider once the related proceeds process completes.",
    TransactionIDInfo: "Unique identifier for a transaction.",
    TriggerNextExecutionDateTooltip: "This schedules the report to be run five minutes from now.",
    UnitPriceTooltip: "The price per share traded.",

  },

  Validation: {
    CalculationLogic: "Please specify the calculation logic.",
    DefaultValue: "Please specify a default value.",
    FailGenerateTransactions: "Failed to generate transactions.",
    InvalidAccount: "Invalid account.",
    InvalidBrokerExportConfiguration: "Invalid Broker Export Configuration",
    InvalidBrokerFileConfiguration: "Invalid broker file configuration.",
    InvalidClientMapping: "Invalid Client Mapping.",
    InvalidColumn: "Invalid Column.",
    InvalidCorporateActionEvent: "Invalid corporate action event.",
    InvalidDataValidationConfiguration: "Invalid data validation configuration.",
    InvalidEvent: "Invalid event details.",
    InvalidFileConfiguration: "Invalid file configuration.",
    InvalidFreeTextEventMapping: "Invalid free text event mapping.",
    InvalidFileImportProcedureConfiguration: "Invalid broker file import procedure configuration.",
    InvalidFilterClause: "Invalid filter clause : must begin with AND or OR",
    InvalidGenericMapping: "Invalid generic mapping.",
    InvalidInstrument: "Invalid instrument.",
    InvalidInstrumentType: "Invalid instrument type.",
    InvalidOrganisation: "Invalid organisation.",
    InvalidStaticEventLookupIndicators: "DWT and Dividend cannot be both be selected.",
    InvalidSecurityTransferDetails: "Invalid security transfer details.",
    InvalidServiceProviderDetails: "Invalid service provider details.",
    InvalidSQL: "Invalid SQL in either the filter or join clause",
    InvalidSQLGenericMapping: "Invalid SQL in calculation",
    InvalidTransaction: "Invalid transaction.",
    InvalidJoinClause: "Invalid join clause : must begin with INNER JOIN, LEFT JOIN, RIGHT JOIN, FULL JOIN, CROSS JOIN or JOIN",
    MissingDateFormat: "Date format must be populated for datetime types.",
    ProvideStartDate: "Please provide a start date.",
    ProvideEndDate: "Please provide an end date.",
    ProvideFileGrouping: "Please provide a file grouping.",
    StartDateBeforeEndDate: "Start Date must be before or the same as End Date.",
    SuccessfullyGeneratedTransactions: "Successfully generated transactions.",
    InvalidTradeOrderEvent: "Invalid trade order event.",
  }
}